const formatMonthLabel = (monthKey) => {
  const year = Number(monthKey.slice(0, 4));
  const month = Number(monthKey.slice(4, 6)) - 1;
  const date = new Date(Date.UTC(year, month, 1));
  if (Number.isNaN(date.getTime())) return monthKey;

  return date.toLocaleDateString("en-US", {
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
};

export const aggregatePointsByMonth = (points = []) => {
  if (!points.length) return [];

  const buckets = new Map();

  points.forEach((point) => {
    const monthKey = point.date?.slice(0, 6);
    if (!monthKey || monthKey.length !== 6) return;

    buckets.set(monthKey, (buckets.get(monthKey) || 0) + (point.value || 0));
  });

  return Array.from(buckets.entries())
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([monthKey, value]) => ({
      date: monthKey,
      monthKey,
      label: formatMonthLabel(monthKey),
      value,
    }));
};

export const toMonthlyTrendView = (trends) => {
  if (!trends?.series?.length) return trends;

  const series = trends.series.map((row) => {
    const points = aggregatePointsByMonth(row.points);
    const total = points.reduce((sum, point) => sum + point.value, 0);

    return {
      ...row,
      points,
      total,
    };
  });

  return {
    ...trends,
    series,
    granularity: "month",
  };
};
